<button
  class="chip {{ variant() }} f-body-m f-medium"
  [class.active]="active()"
  [class.disabled]="disabled()"
>
  @if ((active() && chip().leftActiveIcon) || chip().leftIcon; as icon) {
    <onyx-icon
      [name]="icon.name"
      [size]="icon.size"
      [frame]="icon.frame"
    ></onyx-icon>
  }

  <div class="content">
    <p>{{ chip().name | translate }}</p>

    @if (chip().count != null) {
      <span class="number f-body-xs f-medium">{{ chip().count }}</span>
    }
  </div>
</button>
